// NPM
import React from 'react';
import _ from 'lodash';

// State
import { useSelector } from 'react-redux';

// Services
import renderService from 'services/renderService';
import scrollService from 'services/scrollService';

function TopCredits() {
  const campaignConfig = useSelector(state => state.campaignConfig.value);


  if(!renderService.canRender([campaignConfig])) {
    return null;
  }

  const fromText = _.get(campaignConfig, "sections.TopCredits.fromText", []);

  return (
    <div className="TopCredits">
      <p className="TopCredits__title">
        { fromText }
        &nbsp;
        <a onClick={ () => scrollService.scrollToId("Credits") }>
          Vox Pop Labs
        </a>
      </p>
    </div>
  )

}

export default TopCredits;